import { ButtonHTMLAttributes, FC } from 'react';

import { CloseCircleOutlined } from '@ant-design/icons';

import cn from 'classnames';

import styles from './InputClearIcon.module.scss';

interface IInputClearIconProps extends ButtonHTMLAttributes<HTMLButtonElement> {}

export const InputClearIcon: FC<IInputClearIconProps> = ({ className, ...props }) => {
	return (
		<button className={cn(className, styles.button)} {...props}>
			<CloseCircleOutlined />
		</button>
	);
};
